import type { FC } from 'react';
import { Box, Typography } from '@mui/material';
import XCreativesTable from './XCreativesTable';

interface XCreativesGridProps {
  app?: string;
}

const XCreativesGrid: FC<XCreativesGridProps> = ({ app }) => (
  <Box sx={{ display: 'flex', flexDirection: 'column', gap: 2, flex: 1, width: '100%' }}>
    {app ? (
      <XCreativesTable app={app} />
    ) : (
      <Typography variant="body2" color="text.secondary">
        Select an application to see creatives
      </Typography>
    )}
  </Box>
);

export default XCreativesGrid;
